
import { Component, Vue, Ref, Emit } from 'vue-property-decorator'
import { FormModel } from 'ant-design-vue'
import { Observer } from 'mobx-vue'
import QRCode from 'qrcode'
import { AjaxBasics } from '@xt/client'
import { getDeviceInfo } from '@xt/client/utils/device'
import { getFp } from '@xt/client/utils/fingerprint/report'
import singleToken from '@xt/client/experimental/request/token'
import { reportEntryLog } from '@xt/client/utils/log'

enum EnumQRCodeState {
  /** 待扫描 */
  No_Scan = 0,
  /** 已扫描 */
  Have_Scan = 1,
  /** 已失效 */
  Have_Expire = 2,
  /** 已登录 */
  Have_Login = 3
}

enum EnumAgreementType {
  /** 用户协议 */
  USER = 'user',
  /** 隐私协议 */
  PROVACY = 'privacy'
}

declare global {
  interface Window {
    __wechat_login_win: null | Window
    __wechat_login_success?: boolean
  }
}

type LoginType = 'phone' | 'email' | 'wechat'

@Observer
@Component({
  components: {}
})
export default class extends Vue {
  @Ref('ruleForm')
  ruleForm: FormModel

  qrcodeUrl: any = ''
  scanState: number = 0
  loading: boolean = false
  canvasHeight: number = 174
  canvasWidth: number = 174
  errorQRcode: boolean = false
  clickQRcodeBox: boolean = false

  // 是否展示同意协议弹窗
  agreeVisible = false
  // 临时记录一下用户点击的登录方式 等待同意协议后触发后续流程
  loginType: null | LoginType = null

  // 当前拉起的pc微信登录轮询子窗口

  get PageStore() {
    return this.$store.$storeUser
  }
  get locale() {
    return this.$EnumLocaleLinks
  }
  get EnumQRCodeState() {
    return EnumQRCodeState
  }
  get EnumAgreementType() {
    return EnumAgreementType
  }

  changeCheckState() {
    if (this.scanState === EnumQRCodeState.Have_Scan) return
    this.PageStore.updateCheckState(!this.PageStore.checkState)
  }

  @Emit('valid')
  validAgreement(type) {
    return {
      checkState: this.PageStore.checkState,
      type
    }
  }

  @Emit('toggle')
  onToggle(value) {
    return value //"links_register";
  }

  changeClickStatus() {
    this.clickQRcodeBox = true
    setTimeout(() => {
      this.clickQRcodeBox = false
    }, 500)
  }

  goProtocolPage(e, type) {
    e.stopPropagation()
    let jumpStr = type === EnumAgreementType.USER ? '/protocol/service' : '/protocol/privacy'
    window.open(jumpStr)
  }
  oldTime: number = 0
  boundTime: number = 5 * 60 * 1000
  deadBoundTime: number = (5 * 60 + 10) * 1000
  pausePolling: boolean = false
  timer: ReturnType<typeof setTimeout> | null = null

  handleClickLogin(type: LoginType) {
    // 用户没有勾选已经约定协议开关
    if (!this.PageStore.checkState) {
      this.agreeVisible = true
      this.loginType = type
      return
    }

    this.loginType = null

    if (type === 'phone') {
      this.$emit('valid', {
        type: this.locale.links_phone_login
      })
    } else if (type === 'email') {
      this.$emit('valid', {
        type: this.locale.links_email_login
      })
    } else if (type === 'wechat') {
      this.handleWechatLogin()
    }
  }

  onCancelAgree() {
    this.agreeVisible = false
  }

  onOkAgree() {
    this.agreeVisible = false
    this.PageStore.updateCheckState(true)
    if (this.loginType !== null) {
      this.handleClickLogin(this.loginType)
    }
  }

  async handleWechatLoginSuccess({ code, state }: { code: string; state: string }) {
    reportEntryLog('wxauth.callback.call', { code, state })
    const code4Judge = await this.$store.$storeUser.code4Judge(code)
    // const code4Judge = {
    //   wxExist: false,
    //   phoneExist: false,
    //   emailExist: false,
    //   tempToken: '07dc52d961da2ba05c66a6d3d55b017c'
    // }

    if (!code4Judge) {
      reportEntryLog('wxauth.callback.code4judge-fail', { code, state, r: typeof code4Judge })
      return
    }

    // 先校验是否属于微信独立存在的账号
    if (!code4Judge.phoneExist && !code4Judge.emailExist) {
      console.warn('触发绑定手机号逻辑')
      reportEntryLog('wxauth.callback.single-wechat-account', { code, state })
      this.$emit('valid', { type: this.locale.links_bind_device_login })
      return
    }

    // 返回临时token 直接登录成功
    if (code4Judge.tempToken) {
      reportEntryLog('wxauth.callback.will-login', { code, state })
      await this.$store.$storeUser.onLogin(
        {
          tempToken: code4Judge.tempToken,
          code: ''
        },
        'wx_applets2'
      )
      reportEntryLog('wxauth.callback.login-success', { code, state })
      this.$msg('登录成功，欢迎你桐学 🎉')
      setTimeout(() => {
        window.location.reload()
      }, 50)
    }
  }

  hanldeWechatLoginMessage(event: MessageEvent) {
    if (event.data && event.data.type === 'wechat_auth_success' && event.data.code) {
      window.__wechat_login_success = true
      window.removeEventListener('message', this.hanldeWechatLoginMessage)

      if (window.__wechat_login_win) {
        window.__wechat_login_win.close()
        window.__wechat_login_win = null
        reportEntryLog('wxauth.newwindow.close', {})
      }

      this.handleWechatLoginSuccess({ code: event.data.code, state: event.data.state })
    }
  }

  /**
   * 微信登录
   */
  handleWechatLogin() {
    // mock
    // if (1 === 1) {
    //   this.handleWechatLoginSuccess({ code: '', state: '' })
    //   return
    // }

    // 已经打开了弹窗 且当前弹窗没有被关闭
    if (window.__wechat_login_win && !window.__wechat_login_win.closed) {
      window.__wechat_login_win.focus()
      reportEntryLog('wxauth.newwindow.focus', {})
      return
    }

    // 弹窗已经被关闭则需要重新初始化
    if (window.__wechat_login_win && window.__wechat_login_win.closed === true) {
      window.removeEventListener('message', this.hanldeWechatLoginMessage)
      window.__wechat_login_win = null
      reportEntryLog('wxauth.newwindow.reset', {})
    }

    reportEntryLog('wxauth.btn.click', {})

    const url = new URL('/auth/wechat', location.href)
    url.searchParams.set('t', `${Date.now()}`)

    const handle = window.open(
      url,
      'newwindow',
      'height=470,width=500,top=330,left=710,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=yes,status=no'
    )

    if (!handle) {
      this.$message.error('内置弹窗阻止程序阻止')
      reportEntryLog('wxauth.newwindow.prevent', {})
      return
    }

    window.__wechat_login_success = false
    // 不允许轮询码
    this.pausePolling = true
    this.scanState = EnumQRCodeState.Have_Expire

    // 监听窗口被关闭
    const timer = setInterval(() => {
      console.warn(`轮询检查窗口状态 当前子窗口是否关闭：${handle.closed}`)
      if (handle.closed) {
        // 窗口已经被关闭
        clearInterval(timer)
        window.__wechat_login_win = null

        // 检查是否触发了登录成功事件
        if (!window.__wechat_login_success) {
          this.resetScan()
        }
      }
    }, 1000)

    window.__wechat_login_win = handle

    window.addEventListener('message', this.hanldeWechatLoginMessage, false)
  }

  async pollingGetCodeState(uuid: string) {
    if (!uuid || this.pausePolling) return
    let currentTime = AjaxBasics.serviceDate.valueOf()
    let diff: number = currentTime - this.oldTime
    try {
      let res: any = await this.PageStore.onPollingQrcodeState(uuid)
      if (!res && diff > this.boundTime) {
        this.scanState = EnumQRCodeState.Have_Expire
      }
      switch (res?.qrCodeStatus) {
        case EnumQRCodeState.No_Scan:
          // 超出边界展示失效界面
          if (diff > this.boundTime) {
            this.scanState = EnumQRCodeState.Have_Expire
          }
          // 超出死边界  释放
          if (diff > this.deadBoundTime) {
            return
          }
          break
        case EnumQRCodeState.Have_Scan:
          // 从未扫描进来  重新计算5分10秒
          if (this.scanState === EnumQRCodeState.No_Scan || this.scanState === EnumQRCodeState.Have_Expire) {
            this.oldTime = currentTime
            uuid = res.qrCodeId
          }
          this.scanState = EnumQRCodeState.Have_Scan
          // 超出死边界  释放
          if (diff > this.deadBoundTime) {
            this.scanState = EnumQRCodeState.Have_Expire
            return
          }
          break
        case EnumQRCodeState.Have_Expire:
          // 单纯的实效  释放
          this.scanState = EnumQRCodeState.Have_Expire
          return
        case EnumQRCodeState.Have_Login:
          this.scanState = EnumQRCodeState.Have_Login
          // 设置请求参数
          this.$store.$device.authForPCParams = {
            // 为了和uc上的参数做区分
            tempCode: res.tempToken,
            memberId: res.memberId,
            authDevId: res.ownerDevId
          }
          await singleToken.onLoginByTempToken(res.tempToken, {
            'x-authType': '2'
          })
          // this.PageStore.onToggleVisible(false)
          if (this.PageStore.isLogin()) {
            this.$msg('登录成功，欢迎你桐学 🎉')
            setTimeout(() => {
              window.location.reload()
            }, 50)
          }
          return
        default:
          // 未知异常
          return
      }
      this.timer = setTimeout(() => {
        this.pollingGetCodeState(uuid)
      }, 2000)
    } catch (error) {
      this.errorQRcode = true
    }
  }

  loadImage(url: string) {
    return new Promise(resolve => {
      let img: any = new Image()
      img.setAttribute('crossOrigin', 'anonymous')
      img.src = url
      img.onload = () => resolve(img)
      img.onerror = () => resolve(undefined)
    })
  }
  resetScan() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }

    // 以前卸载组件后使用该变量结束轮询，现在组件没有卸载也有可能结束轮询 后面手动点击重新轮询
    if (this.pausePolling === true) {
      this.pausePolling = false
    }

    this.init()
  }
  async init() {
    if (this.loading) return
    this.loading = true
    this.errorQRcode = false
    this.scanState = EnumQRCodeState.No_Scan
    const deviceInfo = await getDeviceInfo()
    const {
      extra: { canvas, webgl, audio },
      current
    } = await getFp(this.$store.$global)
    let uuid: any = await this.PageStore.onGetLoginQrcode({
      ...deviceInfo,
      canvas,
      webgl,
      audio,
      xtDevId: current
    })
    // let uuid = '47563d6e093e43488e0028235aa949b8'
    this.oldTime = AjaxBasics.serviceDate.valueOf()
    if (!uuid) this.errorQRcode = true
    this.$nextTick(async () => {
      let canvas: any = this.$refs['canvas']
      let ctx = canvas.getContext('2d')
      let dpr = window.devicePixelRatio || 1
      const time = 2
      canvas.width = this.canvasWidth * time * dpr
      canvas.height = this.canvasHeight * time * dpr
      QRCode.toCanvas(
        canvas,
        `${process.env.hubBaseUrl}/hub/uc/index.html?${uuid}`,
        {
          width: canvas.width,
          height: canvas.height,
          color: {
            dark: '#000000',
            light: '#FAF9F7'
          }
        },
        function (error) {
          if (error) console.error(error)
        }
      )
      // @ts-ignore
      let logo: any = await this.loadImage(this.$images.xt_qrcode_logo)
      if (logo) ctx.drawImage(logo, canvas.width / 2 - 30 * dpr, canvas.height / 2 - 30 * dpr, 30 * 2 * dpr, 30 * 2 * dpr)
      let dataUrl = canvas.toDataURL('image/png')
      this.qrcodeUrl = dataUrl
      this.loading = false
      await this.pollingGetCodeState(uuid)
    })
  }
  async created() {
    await this.init()
  }
  mounted() {}
  updated() {}
  destroyed() {
    this.scanState === EnumQRCodeState.No_Scan
    this.pausePolling = true
  }
}
